// extracted by mini-css-extract-plugin
module.exports = {"contenedor":"styles_contenedor__1srU9","titulo":"styles_titulo__eYSBJ","texto":"styles_texto__9uwFs"};